import { ParkInterface } from '@app/app/shared/interfaces/park.interface';
import { ParkStateInterface } from '@app/app/shared/interfaces/park-state.interface';
import { Serialize } from '@app/app/shared/helpers/serialize.helper';
import { ParkAttributesInterface } from '@app/app/shared/interfaces/park-attributes.interface';
import { ThingInterface } from '@app/app/shared/interfaces/thing/thing.interface';
import { ThingAlarmsInterface } from '@app/app/shared/interfaces/thing/thing-alarms.interface';

export class ParkModel implements ParkInterface {
  public id: string;
  public attributes: ParkAttributesInterface;
  public state: ParkStateInterface;
  public test = null;

  constructor(data: any) {
    Object.assign(this, Serialize.snakeToCamel(data));
  }

  public static ser(data) {
    return Serialize.snakeToCamel(data);
  }

  public serialize(): any {
    return Serialize.camelToSnack(this);
  }

  public pending_alarms(): ThingAlarmsInterface[] {
    const alarms = [];

    if (typeof this.attributes.notifications === 'undefined') {
      return alarms;
    }

    Object.keys(this.attributes.notifications).forEach((key) => {
      if (this.attributes.notifications[key].type === 'alarm' && this.attributes.notifications[key].status === 'pending') {
        alarms.push(this.attributes.notifications[key]);
      }
    });

    return alarms;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/park.model.ts